import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom} from "./routerStore";
import {getCompanyResultsStatistics} from "../services/resultsService";
import {activeDateAtom} from "./activeDateStore";

export const activeCompanyResultsAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const activeDate = await get(activeDateAtom);

    return activeCompanyId !== undefined && activeDate !== null
        ? await getCompanyResultsStatistics(activeCompanyId, activeDate.format("YYYY-MM-DD"))
        : {};
});

export const activeCompanyResultsLoadable = loadable(activeCompanyResultsAtom);
